var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFcncaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#006BA6;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.9,518.8V362.4h103.5v27.3H116v37.3h63.6v27.3H116v64.6H82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.9,417.2h-33.4c-0.6-4.3-1.9-8.2-3.7-11.6c-1.9-3.4-4.3-6.3-7.3-8.7c-3-2.4-6.3-4.2-10.2-5.5 c-3.8-1.3-8-1.9-12.5-1.9c-8.1,0-15.1,2-21.1,6c-6,4-10.7,9.8-14,17.4c-3.3,7.6-5,16.8-5,27.7c0,11.1,1.7,20.5,5,28.1 c3.3,7.6,8,13.3,14,17.2c6,3.9,13,5.8,20.8,5.8c4.4,0,8.5-0.6,12.3-1.8c3.8-1.2,7.2-2.9,10.1-5.2c3-2.3,5.4-5,7.4-8.3 c2-3.3,3.3-7,4.1-11.1l33.4,0.2c-0.9,7.2-3,14.1-6.5,20.7c-3.4,6.6-8,12.6-13.8,17.8c-5.8,5.2-12.6,9.3-20.6,12.4 c-8,3-17,4.5-27,4.5c-13.9,0-26.4-3.2-37.4-9.5c-11-6.3-19.6-15.4-26-27.4c-6.3-12-9.5-26.4-9.5-43.4c0-17.1,3.2-31.6,9.6-43.5 c6.4-12,15.1-21.1,26.1-27.4c11-6.3,23.4-9.4,37.1-9.4c9.1,0,17.5,1.3,25.2,3.8c7.8,2.5,14.6,6.2,20.7,11.1 c6,4.9,10.9,10.8,14.7,17.8C335.4,400.1,337.8,408.1,338.9,417.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M485.7,362.4v156.4h-28.6l-68-98.4H388v98.4h-33.1V362.4h29l67.5,98.3h1.4v-98.3H485.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M643.2,417.2h-33.4c-0.6-4.3-1.9-8.2-3.7-11.6c-1.9-3.4-4.3-6.3-7.3-8.7c-3-2.4-6.3-4.2-10.2-5.5 c-3.8-1.3-8-1.9-12.5-1.9c-8.1,0-15.1,2-21.1,6c-6,4-10.7,9.8-14,17.4c-3.3,7.6-5,16.8-5,27.7c0,11.1,1.7,20.5,5,28.1 c3.3,7.6,8,13.3,14,17.2c6,3.9,13,5.8,20.8,5.8c4.4,0,8.5-0.6,12.3-1.8c3.8-1.2,7.2-2.9,10.1-5.2c3-2.3,5.4-5,7.4-8.3 c2-3.3,3.3-7,4.1-11.1l33.4,0.2c-0.9,7.2-3,14.1-6.5,20.7c-3.4,6.6-8,12.6-13.8,17.8c-5.8,5.2-12.6,9.3-20.6,12.4 c-8,3-17,4.5-27,4.5c-13.9,0-26.4-3.2-37.4-9.5c-11-6.3-19.6-15.4-26-27.4c-6.3-12-9.5-26.4-9.5-43.4c0-17.1,3.2-31.6,9.6-43.5 c6.4-12,15.1-21.1,26.1-27.4c11-6.3,23.4-9.4,37.1-9.4c9.1,0,17.5,1.3,25.2,3.8c7.8,2.5,14.6,6.2,20.7,11.1 c6,4.9,10.9,10.8,14.7,17.8C639.7,400.1,642.1,408.1,643.2,417.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M683.2,518.8h-35.4l54-156.4h42.6l53.9,156.4h-35.4l-39.2-120.6h-1.2L683.2,518.8z M681,457.3h83.7v25.8H681 V457.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcncaIcon);
export default __webpack_public_path__ + "static/media/fcnca_icon.ae55e83f014da58e840fe81612e5b07c.svg";
export { ForwardRef as ReactComponent };